import { Controller } from "@hotwired/stimulus"

// The rail as a slide-in panel below md, after UYV-Time's mobile-nav
// controller. Flips body.rail-open, which the CSS turns into the slide and
// the backdrop. Closes on a Turbo visit, on Escape, and when the window
// widens past md.
export default class extends Controller {
  static targets = ["trigger"]

  connect() {
    this.onVisit = () => this.close()
    this.onKey = (event) => { if (event.key === "Escape") this.close() }
    this.desktop = window.matchMedia("(min-width: 768px)")
    this.onResize = () => { if (this.desktop.matches) this.close() }

    document.addEventListener("turbo:visit", this.onVisit)
    document.addEventListener("keydown", this.onKey)
    this.desktop.addEventListener("change", this.onResize)
  }

  disconnect() {
    document.removeEventListener("turbo:visit", this.onVisit)
    document.removeEventListener("keydown", this.onKey)
    this.desktop.removeEventListener("change", this.onResize)
  }

  open() {
    document.body.classList.add("rail-open")
    this.triggerTarget.setAttribute("aria-expanded", "true")
  }

  close() {
    document.body.classList.remove("rail-open")
    if (this.hasTriggerTarget) this.triggerTarget.setAttribute("aria-expanded", "false")
  }
}
